class MultiFactorAuthenticationService {
    constructor(settings, restangularV3) {
        this.settings = settings;
        this._apiV3 = restangularV3.one('authentication/multi-factor');
    }

    getStatus() {
        return this._apiV3.one('status').get();
    }

    getDevices() {
        return this._apiV3.one('devices').get();
    }

    removeDevice(tokenId) {
        return this._apiV3.post('removetoken', { TokenId: tokenId });
    }
}

MultiFactorAuthenticationService.$inject = ['Settings', 'RestangularV3'];

module.exports = MultiFactorAuthenticationService;



// WEBPACK FOOTER //
// ./src/common/multi-factor-authentication/multi-factor-authentication.service.js